module.exports = __webpack_public_path__ + "static/media/logotype_dark.ef347b62.svg";